<template>
  <div class="unauthorized-popup">
    <div class="content">
      <img src="@/assets/images/permission_denied.svg" class="image" alt="permission denied emoji"/>
      <div v-if="accessDeniedMsg" v-html="accessDeniedMsg"/>
      <template v-else>
        <h1 class="title">{{ $t('UNAUTHORIZED_USER') }}</h1>
        <p class="text">{{ $t('CONNECT_FOR_MORE_INFO') }}:</p>
        <a href="tel://052-5665706" class="text-support">052-5665706</a>
        <span class="text-separator"> | </span>
        <a href="mailto:support@classe.world" class="text-support underline">support@classe.world</a>
      </template>
      <router-link class="url" :to="{ name: 'logIn' }">
        <span>{{ $t('TRY_AGAIN') }}</span>
     </router-link>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'unauthorized-popup',

  computed: {
    ...mapState({
      accessDeniedMsg: state => state.base.library?.metadata.access_denied
    })
  }
}
</script>

<style>

</style>
